import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { GameRoutingModule } from './game-routing.module';
import { GameComponent } from './game/game.component';
import { CallFilePageComponent } from './pages/call-file-page/call-file-page.component';
import { ShopCardComponent } from './components/shop-card/shop-card.component';
import { BoxComponent } from './components/box/box.component';
import { ShopTileComponent } from './components/shop-tile/shop-tile.component';
import { TaerraPageComponent } from './pages/taerra-page/taerra-page.component';
import { ButtonBgComponent } from './components/button-bg/button-bg.component';
import { DistrictInfoPageComponent } from './pages/district-info-page/district-info-page.component';
import { SidePanelComponent } from './components/side-panel/side-panel.component';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { Q1FeedbackAllCorrectPageComponent } from './pages/q1-feedback-all-correct/q1-feedback-all-correct-page.component';
import { Q1FeedbackLayoutComponent } from './components/q1-feedback-layout/q1-feedback-layout.component';
import { ButtonComponent } from './components/button/button.component';
import { Q1FeedbackEnoughCorrectPageComponent } from './pages/q1-feedback-enough-correct/q1-feedback-enough-correct-page.component';
import { Q1FeedbackSomeCorrectPageComponent } from './pages/q1-feedback-some-correct/q1-feedback-some-correct-page.component';
import { Q1FeedbackRetailerTileComponent } from './components/q1-feedback-retailer-tile/q1-feedback-retailer-tile.component';
import { DistrictPageComponent } from './pages/district-page/district-page.component';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { NewsPageComponent } from './pages/news-page/news-page.component';
import { NewsLayoutComponent } from './components/news-layout/news-layout.component';
import { KpiPageComponent } from './pages/kpi-page/kpi-page.component';
import { StatsComponent } from './components/stats/stats.component';
import { ShopPageComponent } from './pages/shop-page/shop-page.component';
import { Q2FeedbackLayoutComponent } from './components/q2-feedback-layout/q2-feedback-layout.component';
import { Q2FeedbackPageComponent } from './pages/q2-feedback/q2-feedback-page.component';
import { QComparisonComponent } from './components/q-comparison/q-comparison.component';
import { QEffectiveComponent } from './components/q-effective/q-effective.component';
import { QEffectiveBoxComponent } from './components/q-effective-box/q-effective-box.component';
import { QHintComponent } from './components/q-hint/q-hint.component';
import { AamPageComponent } from './pages/aam-page/aam-page.component';
import { Q3FeedbackPageComponent } from './pages/q3-feedback/q3-feedback-page.component';
import { QProspectsComponent } from './components/q-prospects/q-prospects.component';
import { Q4FeedbackPageComponent } from './pages/q4-feedback/q4-feedback-page.component';
import { QAllComparisonComponent } from './components/q-all-comparison/q-all-comparison.component';
import { QFinalResultComponent } from './components/q-final-result/q-final-result.component';
import { CallFileSinglePageComponent } from './pages/call-file-single-page/call-file-single-page.component';
import { LeaderboardComponent } from './leaderboard/leaderboard.component';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    IonicModule,
    GameRoutingModule,
    PipesModule
  ],
  declarations: [
    GameComponent,
    CallFilePageComponent,
    ShopCardComponent,
    ShopTileComponent,
    BoxComponent,
    TaerraPageComponent,
    ButtonComponent,
    ButtonBgComponent,
    DistrictInfoPageComponent,
    SidePanelComponent,
    LandingPageComponent,
    Q1FeedbackAllCorrectPageComponent,
    Q1FeedbackEnoughCorrectPageComponent,
    Q1FeedbackLayoutComponent,
    Q1FeedbackSomeCorrectPageComponent,
    Q1FeedbackRetailerTileComponent,
    DistrictPageComponent,
    NewsPageComponent,
    NewsLayoutComponent,
    KpiPageComponent,
    StatsComponent,
    ShopPageComponent,
    Q2FeedbackLayoutComponent,
    Q2FeedbackPageComponent,
    QComparisonComponent,
    QEffectiveComponent,
    QEffectiveBoxComponent,
    QHintComponent,
    AamPageComponent,
    Q3FeedbackPageComponent,
    QProspectsComponent,
    Q4FeedbackPageComponent,
    QAllComparisonComponent,
    QFinalResultComponent,
    CallFileSinglePageComponent,
    LeaderboardComponent
  ]
})
export class GameModule {
}
